import AsyncAlpine from 'async-alpine';
import Alpine from 'alpinejs';

AsyncAlpine.init(Alpine);

AsyncAlpine.data(
	'resourceLibrary',
	() => import('/scripts/components/alpine/resource-library.js')
);

AsyncAlpine.start();

Alpine.start();